import React from "react";
import { Menu } from "lucide-react";

const AdminMobileHeader = ({ onMenuClick }) => {
  return (
    <div className="sm:hidden sticky top-0 z-50 bg-slate-800 text-white p-4 flex items-center justify-between border-b border-slate-700">
      <div className="flex items-center">
        <div className="w-8 h-8 bg-purple-600 rounded-lg flex items-center justify-center font-bold mr-2">
          A
        </div>
        <h1 className="text-lg font-bold">Adnaki Admin</h1>
      </div>
      <button
        onClick={onMenuClick}
        className="p-2 hover:bg-slate-700 rounded-md transition-colors"
      >
        <Menu size={24} />
      </button>
    </div>
  );
};

export default AdminMobileHeader;
